import { useMemo } from "react"
import { useBusinesses } from "@/hooks/use-business"
import { useBusinessPlanAccess } from "@/hooks/use-business-plan-access"

export type BusinessOperationalBlockReason = "no_business" | "pending_approval"

export function useBusinessOperationalAccess() {
  const businesses = useBusinesses()
  const { isApproved, isLoading: isLoadingApproval } = useBusinessPlanAccess()

  const hasBusinesses = businesses.length > 0

  return useMemo(() => {
    const blockReason: BusinessOperationalBlockReason | null = !hasBusinesses
      ? "no_business"
      : !isApproved
        ? "pending_approval"
        : null

    return {
      hasBusinesses,
      isApproved,
      isLoading: isLoadingApproval,
      canUseOperationalFeatures: blockReason === null,
      blockReason,
    }
  }, [hasBusinesses, isApproved, isLoadingApproval])
}
